// extracted by mini-css-extract-plugin
export default {"floatbutton":"floatingbutton_floatbutton__qFzC5"};